/**
 * Channel-aware stage labels for the CRM.
 * The underlying DB stage values stay the same — only the display labels swap
 * so the E-commerce funnel reads naturally for retail customers.
 *
 * Mapping
 *   B2B            E-commerce
 *   ──────────     ─────────────
 *   new          → new
 *   contacted    → first-purchase
 *   interested   → repeat-buyer
 *   ordering     → loyal
 *   inactive     → dormant
 *   lost         → churned
 */
export const STAGE_KEYS = ["new", "contacted", "interested", "ordering", "inactive", "lost"];

const LABELS = {
    b2b: {
        new: "new",
        contacted: "contacted",
        interested: "interested",
        ordering: "ordering",
        inactive: "inactive",
        lost: "lost",
    },
    ecommerce: {
        new: "new",
        contacted: "first-purchase",
        interested: "repeat-buyer",
        ordering: "loyal",
        inactive: "dormant",
        lost: "churned",
    },
};

export const stageLabel = (channel, stage) => {
    const ch = channel === "ecommerce" ? "ecommerce" : "b2b";
    return LABELS[ch]?.[stage] || stage;
};

export const STAGE_COLORS = {
    new: "bg-stone-100 text-stone-700",
    contacted: "bg-amber-100 text-amber-800",
    interested: "bg-sky-100 text-sky-800",
    ordering: "bg-emerald-100 text-emerald-800",
    inactive: "bg-stone-200 text-stone-600",
    lost: "bg-red-100 text-red-800",
};
